import { useSelector } from 'react-redux';
import { DistributionType } from '../../models';
import { IApplicationState } from '../../store';
import { DistributionHelper } from '../DistributionHelper';

export const useShouldDisableTestEmail = (distributionType: DistributionType) => {
	const { title, questions } = useSelector((state: IApplicationState) => state.survey.surveyEditModel);

	return title.textValue === '' || questions.length === 0 || !DistributionHelper.usesDistributionList(distributionType);
};
